import React from "react";
import HeaderEn from "../components/header/Header";
import ContentsEn from "../components/pages/joinAttorney/en/Contents";

const JoinAttorney = () => {
  return (
    <>
      <HeaderEn />
      <ContentsEn />
    </>
  );
};

export default JoinAttorney;
